interface PointRuleAdminFormLike {
    getRoot(): HTMLElement;
    getListEl(): HTMLElement | null;
}

interface PointRuleAdminHandlerLike {
    handleListClick(event: MouseEvent): void;
    submitRow(event: SubmitEvent): Promise<void>;
}

export class PointRuleAdminListener {
    public form: PointRuleAdminFormLike;

    public handler: PointRuleAdminHandlerLike;

    public constructor(form: PointRuleAdminFormLike, handler: PointRuleAdminHandlerLike) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.pointRulesAdminBound === "1") {
            return;
        }

        root.dataset.pointRulesAdminBound = "1";

        const listEl = this.form.getListEl();
        if (listEl instanceof HTMLElement) {
            listEl.addEventListener("click", (event) => this.handler.handleListClick(event));
            listEl.addEventListener("submit", (event) => {
                void this.handler.submitRow(event as SubmitEvent);
            });
        }
    }
}
